export const SLACK_COOKIE_KEY = "slack-jwt";
